import {Injectable} from '@angular/core';
import {Observable, Observer} from 'rxjs/Rx';

import {Http, Headers, RequestOptions} from '@angular/http';
import {Response} from '@angular/http';
import {environment} from '../../environments/environment';

@Injectable()
export class FileUploadService {

    public static readonly ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
    public static readonly ALLOWED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png'];

    constructor(
        public http2: Http,
    ) {
    }

    /**
     * True when the selected file is an allowed image (JPG/PNG). Checks the MIME
     * type and falls back to the file extension (some browsers leave type empty).
     */
    isValidImageFile(file): boolean {
        if (!file) {
            return false;
        }
        const type = (file.type || '').toLowerCase();
        const ext = (file.name || '').split('.').pop().toLowerCase();
        return FileUploadService.ALLOWED_IMAGE_TYPES.indexOf(type) !== -1
            || FileUploadService.ALLOWED_IMAGE_EXTENSIONS.indexOf(ext) !== -1;
    }

    uploadFile(path, files, params = {}) {

        return Observable.create(observer => {
            this.compress(files[0]).subscribe((response) => {
                console.log(response);

                let _formData = new FormData();
                _formData.append('file', response);
                _formData.append('params', JSON.stringify(params));
                let body = _formData;
                let headers = new Headers();
                let options = new RequestOptions({
                    headers: headers
                });

                this.http2.post(environment.apiUrl + path, body, options)
                .subscribe((uploadResponse: Response) => {
                    console.log(uploadResponse);
                    observer.next(uploadResponse.json())
                }, (error) => {
                    // Surface server errors (e.g. a 422 for a non-image) instead
                    // of letting the upload hang silently.
                    observer.error(error);
                })
            });
        })


        // return this.compress(files[0]).pipe((response: Response) => {
        //     let _formData = new FormData();
        //     _formData.append('file', response[0]);
        //     _formData.append('params', JSON.stringify(params));
        //     let body = _formData;
        //     let headers = new Headers();
        //     let options = new RequestOptions({
        //         headers: headers
        //     });
        //
        //     return this.http2.post(environment.apiUrl + path, body, options)
        //     .map((uploadResponse: Response) => {
        //         console.log(uploadResponse);
        //         return uploadResponse.json();
        //     })
        // }, (error) => {
        //     console.log(error);
        // })
    }


    compress(file: File): Observable<any> {
        let width = 500; // For scaling relative to width
        const reader = new FileReader();
        reader.readAsDataURL(file);
        return Observable.create(observer => {
            reader.onload = ev => {
                const img = new Image();
                // Without this, a non-image file (e.g. a PDF) never fires onload,
                // so the observer would never emit and the upload hangs silently.
                img.onerror = () => observer.error(new Error('The selected file is not a valid image'));
                img.src = (ev.target as any).result;
                (img.onload = () => {
                    if (img.width < width) {
                        width = img.width;
                    }
                    const elem = document.createElement('canvas'); // Use Angular's Renderer2 method
                    const scaleFactor = width / img.width;
                    elem.width = width;
                    elem.height = img.height * scaleFactor;
                    const ctx = <CanvasRenderingContext2D>elem.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
                    ctx.canvas.toBlob(
                        blob => {
                            observer.next(
                                new File([blob], file.name, {
                                    type: 'image/jpeg',
                                    lastModified: Date.now(),
                                }),
                            );
                        },
                        'image/jpeg',
                        1,
                    );
                }),
                    (reader.onerror = error => observer.error(error));
            };
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/services/FileUploadService.ts